<template>
  <div id="Login">
    <div class="ContentContainer">
      <h3 class="heading-lined">
        {{
          $t(
            !resetPasswordMode
              ? "sign_in_dialog.button.email"
              : "login_page.reset_password"
          )
        }}
      </h3>
      <div v-if="errorMessage" class="alert alert-danger">
        <span>{{ errorMessage }}</span>
      </div>
      <div v-if="!errorMessage && successMessage" class="alert alert-success">
        <span>{{ successMessage }}</span>
      </div>
      <p
        v-html="
          $t(
            !resetPasswordMode
              ? 'sign_in_dialog.p'
              : 'login_page.reset_password_p'
          )
        "
      ></p>
      <form @submit.prevent="onFormSubmit" class="form-group">
        <TextField
          ref="email"
          v-model="email"
          :placeholder="this.$t('login_page.placeholder.email')"
        />
        <TextField
          v-if="!resetPasswordMode"
          ref="password"
          v-model="password"
          type="password"
          class="mt-2"
          :placeholder="this.$t('login_page.placeholder.password')"
        />
        <div class="mt-2 text-right">
          <a
            href="#"
            class="text-muted"
            @click.prevent="toggleResetPasswordMode"
          >
            {{
              $t(
                "login_page.forget_password_text" +
                  (!resetPasswordMode ? "" : "_back")
              )
            }}
          </a>
        </div>
        <ButtonCointracker
          v-if="!resetPasswordMode"
          :disabled="$v.$invalid"
          class="btn-block mt-4"
          :text="this.$t('global.login')"
          type="submit"
        />
        <ButtonCointracker
          v-else
          :disabled="$v.email.$invalid"
          class="btn-primary btn-block mt-4"
          :text="this.$t('login_page.reset_password')"
          type="submit"
        />
      </form>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

import TextField from "../partials/TextField";
import ButtonCointracker from "../specials/ButtonCointracker";

export default {
  name: "Login",
  metaInfo: {
    title: "Login CoinTrackr", 
  },
  components: {
    TextField,
    ButtonCointracker,
  },
  data() {
    return {
      resetPasswordMode: false,
      successMessage: "",

      email: "",
      password: "",
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    errorMessage() {
      let message = this.$store.state.auth.errorMessage;
      if (this.$store.state.auth.errorKey) {
        const key = this.$store.state.auth.errorKey;
        if (key === "auth/invalid-email") {
          message = this.$t("login_page.errors.not_email");
        }
        if (key === "auth/user-not-found") {
          message = this.$t("login_page.errors.email_not_found");
        }
      }
      return message;
    },
  },
  methods: {
    toggleResetPasswordMode() {
      this.resetPasswordMode = !this.resetPasswordMode;
    },
    onFormSubmit() {
      if (this.resetPasswordMode) {
        this.resetPass();
      } else {
        this.signIn();
      }
    },
    async signIn() {
      this.successMessage = "";
      await this.login({
        email: this.email,
        password: this.password,
        type: "email",
      });
      this.$router.push("/");
    },
    async resetPass() {
      this.successMessage = "";
      await this.resetPassword({
        email: this.email,
      });
      this.successMessage = this.$t("login_page.reset_password_success");
      this.resetPasswordMode = false;
    },
    ...mapActions("auth", ["login", "resetPassword"]),
  },
};
</script>
